export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-02.4e169298.jpg";